<template>
  <div class="vto-dsf-warpper" v-if="vto">
    <!-- Dsf Web Component -->
    <dsf-app
      :application="this.vto.application"
      :tenant="this.vto.tenant"
      :customer="this.vto.customer"
      :country="this.vto.country"
      :environment="this.vto.environment"
      :touchpoint="this.vto.touchpoint"
      :type="this.vto.type"
      :vto_type="this.vto.vtotype"
      :vto_category="this.vto.vtocategory"
      :vto_upc_list="this.vto.vto_upc_list"
      :vto_selected_upc="this.vto.vto_selected_upc"
    ></dsf-app>
  </div>
</template>

<script>
export default {
  name: 'DsfAppPlaceholder',
  mounted() {
    if (this.vto) {
      this.dopperFn();
      this.dsfBtnClick();
    }
  },
  props: {
    vto: {
      type: Object,
      required: true,
    },
  },
  methods: {
    dopperFn() {
      let dopperScript = document.createElement('script');
      dopperScript.setAttribute('type', 'application/javascript');
      dopperScript.setAttribute('src', 'https://dsf-cdn.loreal.io/dropper.js');
      dopperScript.setAttribute('auto-run', 'false');
      document.head.appendChild(dopperScript);
    },
    dsfBtnClick() {
      let dsfAppLoaded = false;
      document.body
        .querySelector('.button-open-dsf-app')
        .addEventListener('click', () => {
          if (!dsfAppLoaded) {
            window.dsfDropper.openDsfService('vto');
            dsfAppLoaded = true;
          }
        });
    },
  },
};
</script>

<style>
.vto-dsf-warpper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
